import { Menu, Dropdown, Button, Icon } from '@oscar/theme';
import React from 'react';
import { useAuth, ROLES_NAME } from '../../config';
import './style.scss';

const SwitchRoleDropdown: React.FC = () => {
  const [auth] = useAuth();

  function handleChange(target: any) {
    auth.switchRoles(target.key);
    window.location.reload();
  }

  const menuBtnCreateItems = (
    <Menu
      style={{ fontSize: '16px' }}
      activeKey={auth?.getUserRoles()?.[0]}
      className="switch-roles-select"
    >
      {auth.getValidRoles().map((item: any) => {
        return (
          <Menu.Item key={item} onClick={handleChange}>
            {ROLES_NAME?.[item]}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return auth.getValidRoles().length > 1 ? (
    <Dropdown
      overlay={menuBtnCreateItems}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button className="btn-create-request">
        {ROLES_NAME[auth?.getUserRoles()?.[0]]}&ensp;
        <Icon icon="arrow-down" size={8} color="#ffffff" />
      </Button>
    </Dropdown>
  ) : null;
};

export default SwitchRoleDropdown;
